module.exports = __webpack_public_path__ + "static/media/loading-img.57a32a30.svg";